export default __webpack_public_path__ + "static/media/css3.8fba365c.svg";